import { initCartWidget, visibilityCartWidget } from './cart-widget.js';
import { renderCart, renderCartMessage } from './cart.js';
import { updateCatalogItemStatus, saveCatalogItems } from './catalog-button.js';
import { sendOrderForm } from './order-form.js';
import { initModal} from './order-modal.js';
import { renderCatalogTooltips } from './info-tooltip.js';
import { initSpoilers } from './catalog-card.js';
import {store} from './store.js';
import { showOrederBlockMessage, showOrederBlockLink } from './order-block.js';

function initServiceCatalog() {

  console.log(store);

  renderCart(store);
  renderCartMessage(store);
  showOrederBlockMessage(store);
  showOrederBlockLink(store);
  initCartWidget();
  updateCatalogItemStatus(store);
  saveCatalogItems();
  sendOrderForm(store);
  visibilityCartWidget(store);
  initModal();
  renderCatalogTooltips();
  initSpoilers();
}

export { initServiceCatalog };